// Copyright © 2026 Alex Bruce. All rights reserved.
// Proprietary and confidential. Unauthorized copying, modification,
// or distribution is strictly prohibited.

// ── The second line under a line item ────────────────────────────────────────
//
// An estimate row carried up to three lines: the description, a printed note,
// and who the price came from. The second and third were drawn whether or not
// they held anything, so a thousand-row estimate spent two thousand lines
// saying nothing, and a screen that could have shown forty rows showed
// fourteen. Density is not cosmetic here -- an estimator comparing divisions
// is reading down a column, and every row pushed off the screen is a scroll.
//
// The rule is the same for both: a field earns its line by carrying something,
// or by the estimator having asked for that column. An empty field in a column
// nobody turned on is just a reminder that the field exists, and the column
// menu already says that.
//
// Note what this does NOT do: it never hides a value. A note somebody wrote is
// always visible, whatever the column is set to, because a printed note that
// does not appear on screen is how a client document ends up carrying a
// sentence nobody remembers writing.

/**
 * Whether a row's optional second line should be drawn.
 *
 * @param value    what the field holds, if anything
 * @param columnOn whether the estimator has asked for this column
 */
export function showRowLine(value: unknown, columnOn: boolean): boolean {
  if (typeof value === "string" && value.trim() !== "") return true;
  return !!columnOn;
}
